// Real fixtures keyed to the 6 PDFs in /public/invoices/.
//
// Each fixture is fully populated with:
//  - All required header fields (payment_terms, message_type, mirage_invoice_number,
//    additional_remarks, currency, due_date, amounts, customer_*)
//  - Line items (≥1 per invoice; Hetzner has 8)
//  - ERP per-line metadata (deal_name + acc_assignment + analytic_parts) so the
//    Review screen's "контировки" section renders for every line.
//  - A mirage_counterparty_id pre-selected so the vendor dropdown is filled.
import type { MockInvoice } from '../store'

export const invoiceFixtures: MockInvoice[] = [
  {
    id: 'inv-hetzner-2026-04',
    original_filename: 'Hetzner_2026-04-25_086000816439.pdf',
    file_path: '/invoices/Hetzner_2026-04-25_086000816439.pdf',
    file_size: 84230,
    mime_type: 'application/pdf',
    status: 'review_required',
    overall_confidence: 0.94,
    invoice_type: 'purchase',
    invoice_date: '2026-04-25',
    uploaded_at: '2026-04-26T08:13:00Z',
    processed_at: '2026-04-26T08:14:18Z',
    mirage_counterparty_id: 5001,
    counterparty: {
      id: 5001,
      name: 'Hetzner Online GmbH',
      code: 'HETZ',
      vat_code: 'DE812871812',
      address: 'Industriestr. 25, 91710 Gunzenhausen, Germany',
      country: 'DE',
    },
    extracted: {
      vendor_name: 'Hetzner Online GmbH',
      vendor_tax_id: 'DE812871812',
      vendor_address: 'Industriestr. 25, 91710 Gunzenhausen, Germany',
      vendor_country: 'DE',
      customer_name: 'Гремлинс Лабс ООД',
      customer_tax_id: 'BG207654321',
      customer_address: 'гр. София, ж.к. Изток, ул. "Яворов" 73, ет. 11, ап. 24',
      customer_country: 'BG',
      invoice_number: '086000816439',
      mirage_invoice_number: '0000012345',
      invoice_date: '2026-04-25',
      due_date: '2026-05-09',
      payment_terms: 'По банков път',
      message_type: '01',
      additional_remarks: 'Cloud hosting услуги за м.04 2026',
      currency: 'EUR',
      subtotal: 27.0,
      tax_amount: 5.13,
      total_amount: 32.13,
      vat_rate: 19,
      description: 'Cloud server CX22 - monthly fee',
    },
    line_items: [
      { group: 'li-1', description: 'CPX31 Cloud Server (4 vCPU, 8 GB RAM)', quantity: '1', unit_price: '13.10', unit: 'pcs', line_total: '13.10', vat_rate: '0' },
      { group: 'li-2', description: 'CX22 Cloud Server (2 vCPU, 4 GB RAM)', quantity: '1', unit_price: '4.51', unit: 'pcs', line_total: '4.51', vat_rate: '0' },
      { group: 'li-3', description: 'Primary IPv4 address', quantity: '2', unit_price: '0.50', unit: 'pcs', line_total: '1.00', vat_rate: '0' },
      { group: 'li-4', description: 'Floating IPv4 address', quantity: '1', unit_price: '0.50', unit: 'pcs', line_total: '0.50', vat_rate: '0' },
      { group: 'li-5', description: 'Backup (CPX31)', quantity: '1', unit_price: '2.62', unit: 'pcs', line_total: '2.62', vat_rate: '0' },
      { group: 'li-6', description: 'Backup (CX22)', quantity: '1', unit_price: '0.90', unit: 'pcs', line_total: '0.90', vat_rate: '0' },
      { group: 'li-7', description: 'Volume storage 100 GB', quantity: '1', unit_price: '4.00', unit: 'pcs', line_total: '4.00', vat_rate: '0' },
      { group: 'li-8', description: 'Traffic overage / additional', quantity: '1', unit_price: '0.37', unit: 'pcs', line_total: '0.37', vat_rate: '0' },
    ],
    erp_line_items: buildErpLines(8, { deal_name: 24, acc_assignment: 102, account: '6021' }),
    deal_name_id: 24,
    account_assignment_id: 102,
  },
  {
    id: 'inv-screenshotone',
    original_filename: 'invoice_3191-18539_ScreenshotOne.pdf',
    file_path: '/invoices/invoice_3191-18539_ScreenshotOne.pdf',
    file_size: 56120,
    mime_type: 'application/pdf',
    status: 'review_required',
    overall_confidence: 0.91,
    invoice_type: 'purchase',
    invoice_date: '2026-04-21',
    uploaded_at: '2026-04-22T10:01:00Z',
    processed_at: '2026-04-22T10:02:24Z',
    mirage_counterparty_id: 5002,
    counterparty: {
      id: 5002,
      name: 'Paddle.com Market Ltd (ScreenshotOne)',
      code: 'PADDLE-SS',
      vat_code: 'GB229472108',
      address: 'Judd House, 18-29 Mora St, London EC1V 8BT',
      country: 'GB',
    },
    extracted: {
      vendor_name: 'Paddle.com Market Ltd (ScreenshotOne)',
      vendor_tax_id: 'GB229472108',
      vendor_address: 'Judd House, 18-29 Mora St, London EC1V 8BT',
      vendor_country: 'GB',
      customer_name: 'Гремлинс Лабс ООД',
      customer_tax_id: 'BG207654321',
      customer_address: 'гр. София, ж.к. Изток, ул. "Яворов" 73, ет. 11, ап. 24',
      customer_country: 'BG',
      invoice_number: '3191-18539',
      mirage_invoice_number: '0000012346',
      invoice_date: '2026-04-21',
      due_date: '2026-04-21',
      payment_terms: 'По банков път',
      message_type: '01',
      additional_remarks: 'API screenshot subscription - monthly',
      currency: 'USD',
      subtotal: 17.0,
      tax_amount: 0,
      total_amount: 17.0,
      vat_rate: 0,
      description: 'ScreenshotOne API subscription',
    },
    line_items: [
      { group: 'li-1', description: 'ScreenshotOne API - Basic plan (monthly)', quantity: '1', unit_price: '17.00', unit: 'pcs', line_total: '17.00', vat_rate: '0' },
      { group: 'li-2', description: 'Overage screenshots (above plan)', quantity: '0', unit_price: '0.00', unit: 'pcs', line_total: '0.00', vat_rate: '0' },
    ],
    erp_line_items: buildErpLines(2, { deal_name: 24, acc_assignment: 102, account: '6021' }),
    deal_name_id: 24,
    account_assignment_id: 102,
  },
  {
    id: 'inv-supabase',
    original_filename: 'Invoice-RMGKTU-00016.pdf',
    file_path: '/invoices/Invoice-RMGKTU-00016.pdf',
    file_size: 49210,
    mime_type: 'application/pdf',
    status: 'review_required',
    overall_confidence: 0.96,
    invoice_type: 'purchase',
    invoice_date: '2026-04-05',
    uploaded_at: '2026-04-05T12:30:00Z',
    processed_at: '2026-04-05T12:31:10Z',
    mirage_counterparty_id: 5003,
    counterparty: {
      id: 5003,
      name: 'Supabase Pte Ltd',
      code: 'SUPABASE',
      vat_code: '202210234E',
      address: '970 Toa Payoh North, Singapore 318992',
      country: 'SG',
    },
    extracted: {
      vendor_name: 'Supabase Pte Ltd',
      vendor_tax_id: '202210234E',
      vendor_address: '970 Toa Payoh North, Singapore 318992',
      vendor_country: 'SG',
      customer_name: 'Гремлинс Лабс ООД',
      customer_tax_id: 'BG207654321',
      customer_address: 'гр. София, ж.к. Изток, ул. "Яворов" 73, ет. 11, ап. 24',
      customer_country: 'BG',
      invoice_number: 'RMGKTU-00016',
      mirage_invoice_number: '0000012347',
      invoice_date: '2026-04-05',
      due_date: '2026-04-05',
      payment_terms: 'По банков път',
      message_type: '01',
      additional_remarks: 'Database & backend infrastructure - м.04 2026',
      currency: 'USD',
      subtotal: 34.97,
      tax_amount: 0,
      total_amount: 34.97,
      vat_rate: 0,
      description: 'Supabase Pro plan - monthly subscription',
    },
    line_items: [
      { group: 'li-1', description: 'Supabase Pro plan (monthly subscription)', quantity: '1', unit_price: '25.00', unit: 'pcs', line_total: '25.00', vat_rate: '0' },
      { group: 'li-2', description: 'Compute add-on (Small)', quantity: '1', unit_price: '7.30', unit: 'pcs', line_total: '7.30', vat_rate: '0' },
      { group: 'li-3', description: 'Egress overage (5 GB)', quantity: '5', unit_price: '0.09', unit: 'GB', line_total: '0.45', vat_rate: '0' },
      { group: 'li-4', description: 'Monthly active users overage', quantity: '244', unit_price: '0.0090', unit: 'pcs', line_total: '2.22', vat_rate: '0' },
    ],
    erp_line_items: buildErpLines(4, { deal_name: 24, acc_assignment: 102, account: '6021' }),
    deal_name_id: 24,
    account_assignment_id: 102,
  },
  {
    id: 'inv-paddle-gb',
    original_filename: 'paddle_payment_220820_gb_invoice.pdf',
    file_path: '/invoices/paddle_payment_220820_gb_invoice.pdf',
    file_size: 71200,
    mime_type: 'application/pdf',
    status: 'review_required',
    overall_confidence: 0.92,
    invoice_type: 'sale',
    invoice_date: '2026-04-02',
    uploaded_at: '2026-04-07T09:15:00Z',
    processed_at: '2026-04-07T09:16:02Z',
    mirage_counterparty_id: 5004,
    counterparty: {
      id: 5004,
      name: 'Paddle.com Market Limited',
      code: 'PADDLE-GB',
      vat_code: 'GB229472108',
      address: 'Judd House, 18-29 Mora St, London EC1V 8BT',
      country: 'GB',
    },
    extracted: {
      vendor_name: 'Гремлинс Лабс ООД',
      vendor_tax_id: 'BG207654321',
      vendor_address: 'гр. София, ж.к. Изток, ул. "Яворов" 73, ет. 11, ап. 24',
      vendor_country: 'BG',
      customer_name: 'Paddle.com Market Limited',
      customer_tax_id: 'GB229472108',
      customer_address: 'Judd House, 18-29 Mora St, London EC1V 8BT',
      customer_country: 'GB',
      invoice_number: '220820-GB',
      mirage_invoice_number: '0000012348',
      invoice_date: '2026-04-02',
      due_date: '2026-04-07',
      payment_terms: 'По банков път',
      message_type: '01',
      additional_remarks: 'Payouts - GB sales (March 2026)',
      currency: 'EUR',
      subtotal: 142.85,
      tax_amount: 0,
      total_amount: 142.85,
      vat_rate: 0,
      description: 'Payouts - GB sales (March 2026)',
    },
    line_items: [
      { group: 'li-1', description: 'Net revenue payout - GB (March 2026)', quantity: '1', unit_price: '142.85', unit: 'pcs', line_total: '142.85', vat_rate: '0' },
      { group: 'li-2', description: 'Processing fee adjustment', quantity: '1', unit_price: '0.00', unit: 'pcs', line_total: '0.00', vat_rate: '0' },
    ],
    erp_line_items: buildErpLines(2, { deal_name: 8, acc_assignment: 201, account: '702' }),
    deal_name_id: 8,
    account_assignment_id: 201,
  },
  {
    id: 'inv-paddle-us',
    original_filename: 'paddle_payment_220820_us_invoice.pdf',
    file_path: '/invoices/paddle_payment_220820_us_invoice.pdf',
    file_size: 73450,
    mime_type: 'application/pdf',
    status: 'review_required',
    overall_confidence: 0.93,
    invoice_type: 'sale',
    invoice_date: '2026-04-02',
    uploaded_at: '2026-04-07T09:15:30Z',
    processed_at: '2026-04-07T09:16:35Z',
    mirage_counterparty_id: 5005,
    counterparty: {
      id: 5005,
      name: 'Paddle.com Inc (US)',
      code: 'PADDLE-US',
      vat_code: '47-3580775',
      address: '3811 Ditmars Blvd #1071, Astoria, NY 11105',
      country: 'US',
    },
    extracted: {
      vendor_name: 'Гремлинс Лабс ООД',
      vendor_tax_id: 'BG207654321',
      vendor_address: 'гр. София, ж.к. Изток, ул. "Яворов" 73, ет. 11, ап. 24',
      vendor_country: 'BG',
      customer_name: 'Paddle.com Inc (US)',
      customer_tax_id: '47-3580775',
      customer_address: '3811 Ditmars Blvd #1071, Astoria, NY 11105',
      customer_country: 'US',
      invoice_number: '220820-US',
      mirage_invoice_number: '0000012349',
      invoice_date: '2026-04-02',
      due_date: '2026-04-07',
      payment_terms: 'По банков път',
      message_type: '01',
      additional_remarks: 'Payouts - US sales (March 2026)',
      currency: 'EUR',
      subtotal: 120.85,
      tax_amount: 0,
      total_amount: 120.85,
      vat_rate: 0,
      description: 'Payouts - US sales (March 2026)',
    },
    line_items: [
      { group: 'li-1', description: 'Net revenue payout - US (March 2026)', quantity: '1', unit_price: '120.85', unit: 'pcs', line_total: '120.85', vat_rate: '0' },
      { group: 'li-2', description: 'Currency conversion adjustment', quantity: '1', unit_price: '0.00', unit: 'pcs', line_total: '0.00', vat_rate: '0' },
    ],
    erp_line_items: buildErpLines(2, { deal_name: 8, acc_assignment: 201, account: '702' }),
    deal_name_id: 8,
    account_assignment_id: 201,
  },
  {
    id: 'inv-paddle-remittance',
    original_filename: 'paddle_payment_220820_remittance_advice.pdf',
    file_path: '/invoices/paddle_payment_220820_remittance_advice.pdf',
    file_size: 38110,
    mime_type: 'application/pdf',
    status: 'reviewed',
    overall_confidence: 0.98,
    invoice_type: 'other',
    invoice_date: '2026-04-07',
    uploaded_at: '2026-04-07T09:14:00Z',
    processed_at: '2026-04-07T09:14:42Z',
    mirage_counterparty_id: 5004,
    counterparty: {
      id: 5004,
      name: 'Paddle.com Market Limited',
      code: 'PADDLE-GB',
      vat_code: 'GB229472108',
      address: 'Judd House, 18-29 Mora St, London EC1V 8BT',
      country: 'GB',
    },
    extracted: {
      vendor_name: 'Paddle.com Market Limited',
      vendor_tax_id: 'GB229472108',
      vendor_address: 'Judd House, 18-29 Mora St, London EC1V 8BT',
      vendor_country: 'GB',
      customer_name: 'Гремлинс Лабс ООД',
      customer_tax_id: 'BG207654321',
      customer_address: 'гр. София, ж.к. Изток, ул. "Яворов" 73, ет. 11, ап. 24',
      customer_country: 'BG',
      invoice_number: 'RA-220820',
      mirage_invoice_number: '0000012350',
      invoice_date: '2026-04-07',
      due_date: '2026-04-07',
      payment_terms: 'По банков път',
      message_type: '01',
      additional_remarks: 'Remittance advice for payout 220820',
      currency: 'EUR',
      subtotal: 263.7,
      tax_amount: 0,
      total_amount: 263.7,
      vat_rate: 0,
      description: 'Remittance advice for payout 220820',
    },
    line_items: [
      { group: 'li-1', description: 'Settles invoice 220820-GB', quantity: '1', unit_price: '142.85', unit: 'pcs', line_total: '142.85', vat_rate: '0' },
      { group: 'li-2', description: 'Settles invoice 220820-US', quantity: '1', unit_price: '120.85', unit: 'pcs', line_total: '120.85', vat_rate: '0' },
    ],
    erp_line_items: buildErpLines(2, { deal_name: 8, acc_assignment: 201, account: '702' }),
    deal_name_id: 8,
    account_assignment_id: 201,
  },
]

/**
 * Helper — build `erp_line_items` for N line items with shared deal_name +
 * acc_assignment + analytic_part on a single account code. The analytic part
 * groups every line under "External services / Software" (a typical Mirage
 * level1/level2 structure for SaaS expenses).
 */
function buildErpLines(
  count: number,
  opts: { deal_name: number; acc_assignment: number; account: string }
) {
  return Array.from({ length: count }, (_, i) => ({
    line_item_group: `li-${i + 1}`,
    deal_name: opts.deal_name,
    acc_assignment: opts.acc_assignment,
    analytic_parts: [
      {
        acc: opts.account,
        level1: '001',
        level1_name: 'IT / Cloud services',
        level2: '101',
        level2_name: 'External SaaS',
      },
    ],
  }))
}
